export class PaymentTerm {
  id = 0;
  name = "";
  isActive = true;
}
